import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenSingleImagePreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-single-image-preview-data.interface';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

@Component({
    selector: 'app-gen-display-ad-mobile-18',
    imports: [CommonModule, MobileFrameComponent],
    templateUrl: './display-ad-mobile-18.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './display-ad-mobile-18.component.scss'
})
export class DisplayAdMobile18PreviewComponent {
  @Input() data!: GenSingleImagePreviewData;
}
